import React from "react";
import {observer} from "mobx-react-lite";
import {Grid, Typography} from "@mui/material";

export const PpvOpportunityValidationComponent: React.FC = observer(() => {

    return <Grid>
        <Typography variant="h2">TODO PpvOpportunityValidationComponent</Typography>
    </Grid>
});